module.exports = __webpack_public_path__ + "img/3-en.1555b605.png";